<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <div class="elem elem--span-2"></div>
    <div class="elem elem--span-4 elem--clickable elem--sort">
      <span>Référence</span>
    </div>
    <div class="elem elem--span-5 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="dateEmission"
      />
      <span>Date de paiement</span>
    </div>
    <div class="elem elem--span-5">
      <span>Montant TTC</span>
    </div>
    <div class="elem elem--span-7">
      <span>Bénéficiaire</span>
    </div>
    <div class="elem elem--span-5">
      <span>Facture</span>
    </div>
    <div class="elem elem--span-5">
      <span>Dossier</span>
    </div>
    <div class="elem elem--span-1"></div>
  </div>
</template>

<script setup lang="ts">
  const modelValue = defineModel<string>()
</script>
